// rtk
export default {
    rtk1: 'Нет позиционирования',
    rtk2: 'GPS-позиционирование плохое',
    rtk3: 'Позиционирование решения по одной точке RTK',
    rtk4: 'Дифференциальное позиционирование RTK',
    rtk5: 'Позиционирование решения с плавающей запятой RTK',
    rtk6: 'Позиционирование фиксированного решения RTK',
    rtk7: 'GPS-позиционирование',
}